<template>
  <div class="modal modal--asset">
    <div class="modal__wrapper">
      <div class="modal__close" @click="$emit('close-asset')">
        <fa-icon icon="times"></fa-icon>
      </div>
      <img :src="`${asset}`" alt="asset__generated">
    </div>
  </div>
</template>

<script>
export default {
  name: "AssetModal",
  props: {
    asset: {required: true}
  }
}
</script>
